export default __webpack_public_path__ + "static/media/ic_erase.7c286479.svg";